import type { useComposerCaptureDraftRestorer } from './use-composer-capture-draft-restorer';
type Draft = ReturnType<
  ReturnType<typeof useComposerCaptureDraftRestorer>['captureComposerDraft']
>;

export function isComposerDraft(value: unknown): value is Draft {
  if (!value || typeof value !== 'object') return false;
  const draft = value as Partial<Draft>;
  return (
    typeof draft.serializedText === 'string' &&
    typeof draft.deepResearchEnabled === 'boolean' &&
    Array.isArray(draft.selectedMailConnectorRefs) &&
    Array.isArray(draft.referenceTokenBindings) &&
    Boolean(
      draft.snapshot &&
        typeof draft.snapshot === 'object' &&
        Array.isArray(draft.snapshot.currentAttachments) &&
        Array.isArray(draft.snapshot.currentProductUploads) &&
        Array.isArray(draft.snapshot.currentStyleUploads) &&
        Array.isArray(draft.snapshot.currentColorUploads) &&
        Array.isArray(draft.snapshot.currentSelectedImages) &&
        Array.isArray(draft.snapshot.currentSelectedUserSkills)
    )
  );
}
